import React, { useState } from "react";
import { Link } from "react-router-dom";
import products from "../data/products";

const Footer = () => {
  const year = new Date().getFullYear();
  const [subscribed, setSubscribed] = useState(false);

  const onSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
  };

  return (
    <footer className="site-footer">
      <div className="footer-newsletter">
        <div>
          <h4>Stay in the loop</h4>
          <p>
            Product updates, GST changes that affect your billing, and
            practical ops tips — once a month, no spam.
          </p>
        </div>
        {subscribed ? (
          <p className="footer-newsletter__thanks">
            ✓ Thanks — you're on the list.
          </p>
        ) : (
          <form className="footer-newsletter__form" onSubmit={onSubscribe}>
            <input
              type="email"
              required
              placeholder="Work email"
              aria-label="Work email"
            />
            <button type="submit" className="btn-primary">
              Subscribe
            </button>
          </form>
        )}
      </div>

      <div className="site-footer__grid">
        <div className="footer-col">
          <div className="footer-brand">
            <span className="brand-mark">BF</span>
            <span className="brand-name">Byteflow</span>
          </div>
          <p className="footer-tagline">
            Modular business software for SMBs and manufacturers. ERP, courier,
            pharmacy, education, and e-commerce — built in India.
          </p>
        </div>

        <div className="footer-col">
          <h4>Products</h4>
          <ul>
            {products.map((p) => (
              <li key={p.slug}>
                <Link to={`/products/${p.slug}`}>
                  {p.shortName}
                  {p.flagship && <span className="footer-tag">Flagship</span>}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/products">All products</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li>
              <Link to="/clients">Clients</Link>
            </li>
            <li>
              <Link to="/testimonials">Testimonials</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <ul>
            <li>
              <a href="mailto:info@byteflowinfotech.com">info@byteflowinfotech.com</a>
            </li>
            <li>
              <a href="tel:+919958598952">+91 9958598952</a>
            </li>
            <li>TDI Center, Jasola, Okhla</li>
            <li>New Delhi - 110025</li>
          </ul>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>© {year} Byteflow Pvt Ltd. All rights reserved.</p>
        <div className="footer-socials">
          <a
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            in
          </a>
          <a
            href="https://twitter.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            tw
          </a>
          <a
            href="https://github.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            gh
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
